exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/bi-reporting-config/new-widget/new-widget.component.css
// module id = ../../../../../src/app/bi-reporting-config/new-widget/new-widget.component.css
// module chunks = main